import React from 'react';
import { Box, Button } from '@mui/material';
import { statusTabButtonSx } from '../Common/inventory.helper';
import { consumptionLogtabsDetails, consumptionMaintabsDetails } from '../MaterialConsumption/MaterialConsumption.helper';
import { logstabsDetails } from '../../RFID/RFIDHelper';

interface StatusTabOption {
  label: string;
  value: string;
  count: number;
}

interface StatusTabButtonGroupProps {
  options: StatusTabOption[] | consumptionLogtabsDetails[] | consumptionMaintabsDetails[] | logstabsDetails[];
  selected: string;
  onChange: (value: string) => void;
}

const StatusTabButtonGroup: React.FC<StatusTabButtonGroupProps> = ({ options, selected, onChange }) => {
  return (
    <Box display="flex" gap={2} >
      {options.map((item) => {
        const isSelected = selected === item.value;
        return (
          <Button
            key={item.label}
            onClick={() => onChange(item.value)}
            disableRipple
            variant="outlined"
            sx={statusTabButtonSx(isSelected)}
          >
            {item.label}{'count' in item && item.count !== undefined ? ` (${item.count})` : ''}
          </Button>
        );
      })}
    </Box>
  );
};

export default StatusTabButtonGroup;
